export interface PlaybackShortcutInput {
  key: string;
  code: string;
  repeat: boolean;
  altKey: boolean;
  ctrlKey: boolean;
  metaKey: boolean;
  shiftKey: boolean;
  hasInteractiveTarget: boolean;
}

export type PlaybackShortcutAction = "toggle" | "rewind" | "fast-forward";
export type PlaybackGestureDirection = "rewind" | "fast-forward";

export const playbackGestureOffsetMs = (direction: PlaybackGestureDirection): number =>
  direction === "rewind" ? -10_000 : 10_000;

export const playbackShortcutAction = (input: PlaybackShortcutInput): PlaybackShortcutAction | null => {
  if (
    input.altKey || input.ctrlKey || input.metaKey || input.shiftKey ||
    input.hasInteractiveTarget
  ) return null;
  if ((input.key === " " || input.code === "Space") && !input.repeat) return "toggle";
  if (input.key === "ArrowLeft" || input.code === "ArrowLeft") return "rewind";
  if (input.key === "ArrowRight" || input.code === "ArrowRight") return "fast-forward";
  return null;
};
